module.exports = __webpack_public_path__ + "img/upload_cloud.8f6f1fe9.svg";